import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import OrderForm from './OrderForm';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiCheck, FiTruck } = FiIcons;

const OfferSection = () => {
  const [isOrderFormOpen, setIsOrderFormOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState('ebook');

  const handleOrderClick = (packageType) => {
    setSelectedPackage(packageType);
    setIsOrderFormOpen(true);
  };

  return (
    <section id="offer-section" className="py-20 px-4 bg-[#F5F5F5]">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-8" 
              style={{ fontFamily: 'Kanit, sans-serif' }}>
            เลือกจังหวะที่ใช่สำหรับคุณ
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* E-Book Package */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl p-8 shadow-lg border-2 border-gray-200 hover:shadow-xl transition-all duration-300"
          >
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-[#333333] mb-2" 
                  style={{ fontFamily: 'Kanit, sans-serif' }}>
                E-BOOK
              </h3>
              <div className="w-32 h-40 mx-auto mb-4 rounded-lg overflow-hidden shadow-lg">
                <img 
                  src="https://static.wixstatic.com/media/4fbfa6_d8ac54a7a1dd459abcc3031a27d29bdf~mv2.png"
                  alt="E-Book แค่หายใจก็เหนื่อย"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiCheck} className="text-[#556B2F] text-lg" />
                <span style={{ fontFamily: 'Sarabun, serif' }}>
                  E-Book "แค่หายใจก็เหนื่อย? ลองใช้ชีวิต 24 ซีซั่นดู"
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiCheck} className="text-[#556B2F] text-lg" />
                <span style={{ fontFamily: 'Sarabun, serif' }}>
                  ฟรี! E-Course VDO (มูลค่า 3,999.-)
                </span>
              </div>
            </div>

            <div className="text-center">
              <div className="text-3xl font-bold text-[#E07A5F] mb-6">199 บาท</div>
              <button
                onClick={() => handleOrderClick('ebook')}
                className="w-full bg-[#6082B6] hover:bg-[#4a6b94] text-white font-bold py-3 px-6 rounded-full transition-all duration-300 transform hover:scale-105"
              >
                สั่งซื้อ E-Book
              </button>
            </div>
          </motion.div>

          {/* Hard Copy Package - Featured */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl p-8 shadow-2xl border-2 border-[#E07A5F] hover:shadow-3xl transition-all duration-300 transform hover:scale-105 relative"
          >
            {/* Best Seller Badge */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <div className="bg-[#E07A5F] text-white px-6 py-2 rounded-full font-bold text-sm flex items-center space-x-2">
                <SafeIcon icon={FiStar} className="text-yellow-300" />
                <span>คุ้มที่สุด</span>
              </div>
            </div>

            <div className="text-center mb-6 mt-4">
              <h3 className="text-2xl font-bold text-[#333333] mb-2" 
                  style={{ fontFamily: 'Kanit, sans-serif' }}>
                HARD COPY
              </h3>
              <div className="relative">
                <div className="w-32 h-40 mx-auto mb-4 rounded-lg overflow-hidden shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-300">
                  <img 
                    src="https://static.wixstatic.com/media/4fbfa6_d8ac54a7a1dd459abcc3031a27d29bdf~mv2.png"
                    alt="หนังสือปกแข็ง แค่หายใจก็เหนื่อย"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiCheck} className="text-[#E07A5F] text-lg" />
                <span style={{ fontFamily: 'Sarabun, serif' }}>
                  หนังสือปกแข็ง "แค่หายใจก็เหนื่อย? ลองใช้ชีวิต 24 ซีซั่นดู"
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiTruck} className="text-[#E07A5F] text-lg" />
                <span style={{ fontFamily: 'Sarabun, serif' }}>
                  ส่งฟรีทั่วประเทศ
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiCheck} className="text-[#E07A5F] text-lg" />
                <span style={{ fontFamily: 'Sarabun, serif' }}>
                  แถมฟรี! E-Book Version
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiCheck} className="text-[#E07A5F] text-lg" />
                <span style={{ fontFamily: 'Sarabun, serif' }}>
                  ฟรี! E-Course VDO (มูลค่า 3,999.-)
                </span>
              </div>
            </div>

            <div className="text-center">
              <div className="text-3xl font-bold text-[#E07A5F] mb-6">395 บาท</div>
              <button
                onClick={() => handleOrderClick('hardcopy')}
                className="w-full bg-[#E07A5F] hover:bg-[#d16847] text-white font-bold py-4 px-6 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                สั่งซื้อฉบับปกแข็ง
              </button>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Order Form Modal */}
      <OrderForm 
        isOpen={isOrderFormOpen} 
        onClose={() => setIsOrderFormOpen(false)} 
        selectedPackage={selectedPackage} 
      />
    </section>
  );
};

export default OfferSection;